import React, { ChangeEvent, FC } from "react";
import { useTranslation } from "react-i18next";
import { useField } from "formik";
import { IFormField } from "src/@types/form";
import { FormField } from "src/components/FormField";
import { MultiFileInput } from "../FileInput/MultiFileInput";

export const MultiDocField: FC<IFormField> = ({
  className,
  fieldClassName,
  labelClassName,
  id,
  label,
  placeholder,
  accept,
  errorClassName,
  ...props
}) => {
  const { t } = useTranslation();

  const fieldId = id || (props.name as string);

  const [fieldProps, fieldMeta, fieldHelpers] = useField<File[]>(fieldId);
  const { value } = fieldProps;
  const { error, touched } = fieldMeta;
  const { setValue, setTouched } = fieldHelpers;

  const isShownError = Boolean((touched || value.length) && error);

  const placeholderText =
    typeof placeholder === "string"
      ? placeholder
      : placeholder && t(placeholder.i18nKey, placeholder.i18nParams);

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const filesArr = Array.from(event.target.files);
    // filter out files that are already in the 'value' array
    const uniqueFiles = filesArr.filter((newFile) => {
      return !value.some((oldFile) => {
        const isSameName = newFile.name === oldFile.name;
        const isSameSize = newFile.size === oldFile.size;
        return isSameName && isSameSize; //isSameFile
      });
    });

    setTouched(true);
    setValue([...value, ...uniqueFiles]);
  };

  const onDelete = (file: File) => {
    const updatedFiles = value.filter(({ name }) => name !== file.name);
    setValue(updatedFiles);
  };

  return (
    <FormField
      className={fieldClassName}
      labelClassName={labelClassName}
      label={label}
      labelFor={fieldId}
      isShownError={isShownError}
      error={error}
      errorClassName={errorClassName}
    >
      <MultiFileInput
        files={value}
        id={fieldId}
        accept={accept}
        className={className}
        placeholder={placeholderText}
        isUploaded={Boolean(value?.length && !isShownError)}
        onChange={onChange}
        onDelete={onDelete}
      />
    </FormField>
  );
};
